import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";
import { initScroll } from "./lib/scroll.js";
import { initHeader, responsiveHeaderNav } from "./lib/header.js";
import { initComponents } from "./components/components";
import { initEvents } from "./lib/events.js";
import ImpactReport from "./components/impact-report.js";

document.addEventListener("DOMContentLoaded", function () {
	initScroll();
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();
	initHeader();
	initComponents();
	initEvents();

	if (document.body.classList.contains("page-template-impact-report")) {
		ImpactReport.init();
	}
});
